import { fromPairs } from 'lodash/fp';

import {
  ApiListRelationship,
  ApiModel,
  ApiRelationship,
  ApiResource,
  ApiResponse,
} from 'lib/interfaces/api';

// app/models/concerns/relation_serializable.rb
type RelationKey = `relation-${string}`;

export interface RelationsOnRelationships {
  [key: RelationKey]: ApiListRelationship | ApiRelationship;
}

export type Relations = Record<string, ApiRelationship | ApiListRelationship>;

const PREFIX_RELATION_ON_RELATIONSHIPS = 'relation-';

export const pickRelationsFromAPIResponse = (
  response: ApiResponse<ApiResource<unknown, RelationsOnRelationships>>,
): Relations =>
  fromPairs(
    Object.entries(response.data.relationships)
      .filter(([key]) => key.startsWith(PREFIX_RELATION_ON_RELATIONSHIPS))
      .map(([key, value]) => [
        key.replace(new RegExp(`^${PREFIX_RELATION_ON_RELATIONSHIPS}`), ''),
        value,
      ]),
  );

export interface RelationSchema {
  key: string;
  label: string;
  cardinality: 'one' | 'many';
  token: string;
  type: ApiModel.AccountType | ApiModel.TransactionType;
  'inverse-key'?: string;
  'inverse-cardinality'?: 'one' | 'many';
  'inverse-label'?: string;
}
